/* A time interval, defined by a well-formed start date and an optional end date */
export interface TimeInterval {
  start: Date;
  end?: Date;
}

/*
 * Returns a boolean indicating whether two intervals A and B overlap each other
 */
export const intervalsOverlap = (
  intervalA: TimeInterval,
  intervalB: TimeInterval,
) => {
  if (intervalA.end && intervalB.end) {
    return intervalA.start <= intervalB.end && intervalA.end >= intervalB.start;
  }
  if (!intervalA.end && !intervalB.end) {
    // Two intervals without defined ends always overlap each other
    return true;
  }
  if (intervalA.end) {
    return intervalB.start <= intervalA.end;
  }
  if (intervalB.end) {
    return intervalA.start <= intervalB.end;
  }
  return false;
};

/*
 * Returns a boolean indicating whether a given date is contained within a given interval
 */
export const intervalContains = (
  interval: TimeInterval,
  date : Date,
) => {
  if (interval.end) {
    return interval.start <= date && date <= interval.end;
  }
  return interval.start <= date;
};
